import { ClientScoreHealthRangeProps } from '..';
import { ClientScoreHealthRange } from '../ScoreHealthRange';
import { INSURANCE_RATE_SCORE_HEALTH_RANGE_BREAKPOINTS } from './constants';
import { INSURANCE_RATE_SCORECARD_ELEMENT_SYMBOL } from '../../../Scorecard';

export function ClientInsuranceRateScoreHealthRange(props: Omit<ClientScoreHealthRangeProps, 'breakpoints' | 'element'>) {
  return (
    <ClientScoreHealthRange
      {...props}
      element={INSURANCE_RATE_SCORECARD_ELEMENT_SYMBOL}
      breakpoints={INSURANCE_RATE_SCORE_HEALTH_RANGE_BREAKPOINTS}
    />
  );
}
